import * as React from 'react';
import Common from './BOM/Common';
import useReduxState from "../hooks/useReduxState";
import { useSearchParams } from "react-router-dom";
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';

export function BOM() {
    const [_check_p] = useCheckAuthPermissions();
    const [searchParams] = useSearchParams();
    const [BOM__Component__Loader] = useReduxState(searchParams.get(Common.param_key) ? searchParams.get(Common.param_key) : Common.default_component.param_value, Common.redux_key);
    return (
        <>
            { _check_p('VIEW_BOM').status &&
                <div className="logged-screen">
                    <div className="">
                        {React.createElement(Common.chain[BOM__Component__Loader].element)}
                    </div>
                </div>
            }
        </>
    );
}